import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import {ReactSVG} from "react-svg";
import iconSignUp from "@Icons/SVG/icon-sign-up.svg";


import HeaderComponent from "@Components/Elements/TextElements/Header";

import {FormComponent, InputComponent} from "@Components/Forms";
import SectionContainerComponent from "@Components/Sections/SectionContainer";
import HomePageSignUpForm from "@Pages/@HomePage/SignUpSection/SignUpForm";


export const HomePageSignUpSection:React.FC = () => {

    return (
        <SectionContainerComponent id={'home-page__sign-up-form'}>

            <Col xs={12} xl={6} className={'home-page__sign-up-form__text-information'}>
                <Row className={'home-page__sign-up-form__text-information__content'}>
                    <Col xs={12} className={'home-page__sign-up-form__text-information__header-icon'}>
                        <ReactSVG src={iconSignUp} wrapper={'span'} />
                    </Col>
                    <HeaderComponent
                        type={'h1'}
                        text={'Sign Up'}
                        cssClasses={['home-page__sign-up-form__text-information__header']}
                    />
                    <Col xs={12} className={'home-page__sign-up-form__text-information__disclaimer'}>
                        <p>Sign Up now to claim your spot on the early access list and be one of the first to use Qyvo.</p>
                    </Col>
                    <Col xs={12} className={'home-page__sign-up-form__text-information__message'}>
                        <p>We'll email you as soon as we go live, with early access, exciting news, and exclusive perks for early users.</p>
                    </Col>
                </Row>
            </Col>

            <HomePageSignUpForm />

        </SectionContainerComponent>
    );

};


export default HomePageSignUpSection;
